import { CLUSTER_BOUNDS_PADDING, EventLocationData, MAP_FLY_TO_DURATION, ZOOM, useHistorySearch } from '@eagle/react-common';
import L from 'leaflet';
import { FC, useEffect, useMemo } from 'react';
import { useMap } from 'react-leaflet';
import { getEventLatLng } from '../trip-history-base-view-utils';
import { ThingRangeMapViewportControllerProps } from '../trip-history-base-view.types';

export const ThingRangeMapViewportController: FC<ThingRangeMapViewportControllerProps> = ({ events, focusEvent, isActive, journeyId, selectedEventId }) => {
  const map = useMap();
  const { eventData } = useHistorySearch();
  const mapItem = eventData.find((item) => item.journeyId === journeyId);
  const mapEvents = useMemo(() => mapItem?.data.items ?? [], [mapItem?.data.items]);
  const mapPoints = useMemo(() => {
    return mapEvents
      .map((event) => getEventLatLng(event as EventLocationData))
      .filter((point): point is L.LatLng => Boolean(point));
  }, [mapEvents]);
  const selectedEvent = useMemo(() => {
    if (!selectedEventId) return;
    return events.find((event) => event.eventId === selectedEventId);
  }, [events, selectedEventId]);

  useEffect(() => {
    if (!isActive || selectedEventId || focusEvent || !mapPoints.length) return;
    map.flyToBounds(L.latLngBounds(mapPoints).pad(CLUSTER_BOUNDS_PADDING), { duration: MAP_FLY_TO_DURATION });
  }, [focusEvent, isActive, map, mapPoints, selectedEventId]);

  useEffect(() => {
    if (!isActive) return;
    const selectedEventPoint = getEventLatLng(focusEvent ?? selectedEvent);
    if (!selectedEventPoint) return;
    map.flyTo(selectedEventPoint, Math.max(map.getZoom(), ZOOM.street), { duration: MAP_FLY_TO_DURATION });
  }, [focusEvent, isActive, map, selectedEvent]);

  return <></>;
};

